import { forEach } from 'remeda'

// Public types ----------------------------------------------------------------

export type Cleanup = () => void

// Public functions ------------------------------------------------------------

// Runs every supplied cleanup at one explicit effect boundary.
export const composeCleanup =
  (...cleanups: readonly Cleanup[]): Cleanup =>
  () => {
    forEach(cleanups, (cleanup) => cleanup())
  }
